export const TAB_CUSTOMER_ABOUT = 'about'
export const TAB_CUSTOMER_USER = 'user'
export const TAB_CUSTOMER_PRESS_REVIEW = 'press_review'
export const TAB_CUSTOMER_MAILING_LIST = 'mailing_list'
export const TAB_PRESS_COVERAGE = 'press_coverage'
export const TAB_CUSTOMER_API_USER = 'api_user'
